/**
 * Écran 404 (`*`).
 *
 * Toute adresse inconnue reste dans l’application (pas de page blanche, pas de texte anglais du
 * navigateur) et propose un retour vers l’accueil.
 */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Entete } from '../ui/Entete';

export function EcranIntrouvable() {
  const { t } = useTranslation();
  return (
    <div className="ecran ecran--centree">
      <Entete />
      <main className="panneau message-erreur">
        <h1 className="formulaire__titre">{t('introuvable.titre')}</h1>
        <p>{t('introuvable.texte')}</p>
        <Link to="/">{t('introuvable.lien')}</Link>
      </main>
    </div>
  );
}
